export default __webpack_public_path__ + "static/media/strategy.727811c6.svg";